import { render } from "./NodrizerComponent.vue?vue&type=template&id=a77c6aaa&scoped=true"
import script from "./NodrizerComponent.vue?vue&type=script&lang=js"
export * from "./NodrizerComponent.vue?vue&type=script&lang=js"

import "./NodrizerComponent.vue?vue&type=style&index=0&id=a77c6aaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77c6aaa"]])

export default __exports__